<template>
  <div class="block">
    <div class="block-wrap">
      <div class="title-box" v-if="type == 'home'">
        <h2 class="h2">项目展示</h2>
        <router-link to="/project/1" class="lookMore">查看更多<i class="el-icon-arrow-right" /></router-link>
      </div>
    </div>
    <div class="block-wrap news_wrap">
      <div class="news_detail" style="flex-wrap: wrap;">
        <div class="news-item" v-for="(item, index) in newsList.slice(0, 3)" :key="index" @click="handleToNewsDetails(item.id)">
          <img :src="item.preview_image" class="picture" />
          <h2 class="h2">{{ item.title }}</h2>
          <div class="flex">
            <p class="desc">{{ item.jieshao }}</p>
            <el-button class="btn">立即捐赠</el-button>
          </div>
        </div>
      </div>
      <div class="news_detail" style="flex-wrap: wrap;" v-if="shouye_project_show == 6">
        <div class="news-item" v-for="(item, index) in newsList.slice(3, 6)" :key="index" @click="handleToNewsDetails(item.id)">
          <img :src="item.preview_image" class="picture" />
          <h2 class="h2">{{ item.title }}</h2>
          <div class="flex">
            <p class="desc">{{ item.jieshao }}</p>
            <el-button class="btn">立即捐赠</el-button>
          </div>
        </div>
      </div>
      <div class="pagination" v-if="type != 'home'">
        <el-pagination layout="slot" :total="total" :current-page="page" hide-on-single-page>
          <div>
            <el-button type="text" class="custom-btn" :disabled="page <= 1" @click="handlePrevChange">
              <i class="el-icon-arrow-left"></i>
              上一页
            </el-button>
            <el-button type="text" class="custom-btn" :disabled="page >= lastPage" @click="handleNextChange">
              下一页
              <i class="el-icon-arrow-right"></i>
            </el-button>
          </div>
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import CifuAPI from "@/utils/api";
import { mapState } from "vuex";

export default {
  props: {
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      newsList: [],
      page: 1,
      total: 0,
      lastPage: 1,
      shouye_project_show: ''
    };
  },
  created() {
    this.getConfig()
  },
  computed: {
    ...mapState(["platform"]),
    isWrap() {
      if (this.platform == "mobile") {
        return false;
      } else {
        return true
      }
    },
  },
  watch: {
    $route: {
      handler(to) {
        this.getList(to.query.type);
      },
      immediate: true, // 首次加载立即执行
    },
  },
  methods: {
    async getConfig() {
      let res = await CifuAPI.getConfig()
      if (res.code == 1) {
        this.shouye_project_show = res.data.shouye_project_show
      }
    },
    async getList(type) {
      const params = {
        is_shouye_show: this.type == "home" ? 1 : undefined,
        project_cate_id: type,
        limit: this.shouye_project_show,
        page: this.page,
      };
      const res = await CifuAPI.getProjectList(params);
      if (res.code == 1) {
        this.newsList = res.data.data
        this.total = res.data.total;
        this.lastPage = res.data.last_page;
      }
    },
    handlePrevChange() {
      this.page--;
      this.getList();
    },
    handleNextChange() {
      this.page++;
      this.getList();
    },
    handleToNewsDetails(id) {
      this.$router.push("/projectDetail?type=1&id=" + id);
    },
  },
};
</script>

<style lang="scss" scoped>
.more {
  height: 50px;
  text-align: right;
}

.news_wrap {
  min-width: 1400px; // 设置合理的固定宽度，类似韩红基金会
  // 处理浏览器放大后的情况
  @media screen and (min-width: 1401px) {
    min-width: auto; // 1200px以上恢复完全响应式
  }
  @media screen and (max-width: 1400px) {
    min-width: 1400px; // 1200px以下固定宽度，不再缩小
  // 处理浏览器放大后的情况
  @media screen and (min-width: 1401px) {
    min-width: auto; // 1200px以上恢复完全响应式
  }  }
  
  // // 只在真正的移动设备上应用移动端样式
  // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
  //   min-width: auto; // 移动端不限制最小宽度
  // }
  
  .news_detail {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    gap: 40px;
    @media screen and (max-width: 1400px) {
      gap: 35px;
    }
    
    @media screen and (max-width: 1400px) {
      gap: 30px; // 1200px以下不再缩小
    }
    
    // 只在真正的移动设备上应用移动端样式
    // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
    //   flex-direction: column;
    //   gap: 20px;
    // }
    .news-item {
      flex: 1;
      display: flex;
      flex-direction: column;
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
      // box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      margin-top: 20px;
      transition: transform 0.3s ease, box-shadow 0.3s ease;
      
      @media screen and (max-width: 1400px) {
        border-radius: 6px;
      }
      
      // @media screen and (max-width: 768px) {
      //   border-radius: 4px;
      // }
      
      &:hover {
        transform: translateY(-5px);
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
        
        // @media screen and (max-width: 768px) {
        //   transform: none;
        //   box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        // }
      }
      
      .picture {
        width: 100%;
        object-fit: cover;
        
        @media screen and (max-width: 1400px) {
          height: 260px;
        }
        
        @media screen and (max-width: 1400px) {
          height: 240px; // 1200px以下不再缩小
        }
        
        // @media screen and (max-width: 768px) {
        //   height: 180px;
        // }
        
        // @media screen and (max-width: 480px) {
        //   height: 160px;
        // }
      }
      
      .h2 {
        padding: 20px 20px 15px;
        font-size: 22px;
        font-weight: bold;
        color: #663301;
        line-height: 1.4;
        
        @media screen and (max-width: 1400px) {
          padding: 18px 18px 13px;
          font-size: 20px;
        }
        
        @media screen and (max-width: 1400px) {
          padding: 16px 16px 12px;
          font-size: 19px; // 1200px以下不再缩小
        }
        
        // @media screen and (max-width: 768px) {
        //   padding: 12px 12px 8px;
        //   font-size: 16px;
        // }
        
        // @media screen and (max-width: 480px) {
        //   padding: 10px 10px 6px;
        //   font-size: 15px;
        // }
      }
      
      .flex {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        flex: 1;
        padding: 0 20px 20px;
        
        @media screen and (max-width: 1400px) {
          padding: 0 18px 18px;
        }
        
        @media screen and (max-width: 1400px) {
          padding: 0 16px 16px; // 1200px以下不再缩小
        }
        
        // @media screen and (max-width: 768px) {
        //   padding: 0 12px 12px;
        // }
        
        // @media screen and (max-width: 480px) {
        //   padding: 0 10px 10px;
        // }
        
        .desc {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          text-overflow: ellipsis;
          padding-bottom: 20px;
          font-size: 16px;
          color: #4f4f4f;
          line-height: 1.6;
          
          @media screen and (max-width: 1400px) {
            font-size: 15px;
            padding-bottom: 18px;
          }
          
          @media screen and (max-width: 1400px) {
            font-size: 15px;
            padding-bottom: 16px; // 1200px以下不再缩小
          }
          
          // @media screen and (max-width: 768px) {
          //   font-size: 13px;
          //   padding-bottom: 12px;
          //   -webkit-line-clamp: 2;
          // }
          
          // @media screen and (max-width: 480px) {
          //   font-size: 12px;
          //   padding-bottom: 10px;
          // }
        }
        
        .btn {
          width: 100%;
          height: 45px;
          background: #fbce00;
          border: none;
          border-radius: 25px;
          font-size: 16px;
          color: #663301;
          font-weight: bold;
          transition: all 0.3s ease;
          
          @media screen and (max-width: 1400px) {
            height: 42px;
            font-size: 15px;
          }
          
          @media screen and (max-width: 1400px) {
            height: 40px;
            font-size: 15px; // 1200px以下不再缩小
          }
          
          // @media screen and (max-width: 768px) {
          //   height: 40px;
          //   font-size: 14px;
          // }
          
          // @media screen and (max-width: 480px) {
          //   height: 38px;
          //   font-size: 13px;
          // }
          
          &:hover {
            background: #f0c000;
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(251, 206, 0, 0.3);
            
            // @media screen and (max-width: 768px) {
            //   transform: none;
            //   box-shadow: none;
            // }
          }
        }
      }
    }
  }
}

.video {
  width: 100%;
  min-width: 1400px; // 设置合理的固定宽度，类似韩红基金会
  height: 300px;
  
  // 处理浏览器放大后的情况
  @media screen and (min-width: 1401px) {
    min-width: auto; // 1200px以上恢复完全响应式
  }
  
  @media screen and (max-width: 1400px) {
    height: 280px;
    min-width: 1400px; // 1200px以下固定宽度
  }
  
  // 只在真正的移动设备上应用移动端样式
  // @media screen and (max-width: 768px) and (hover: none) and (pointer: coarse) {
  //   height: auto;
  //   min-width: auto; // 移动端不限制最小宽度
  // }
  
  &-list {
    display: flex;
    padding-top: 50px;
    gap: 40px;
    
    @media screen and (max-width: 1400px) {
      padding-top: 45px;
      gap: 35px;
    }
    
    @media screen and (max-width: 1400px) {
      padding-top: 40px;
      gap: 30px; // 1200px以下不再缩小
    }
    
    // @media screen and (max-width: 768px) {
    //   flex-direction: column;
    //   padding-top: 20px;
    //   gap: 20px;
    // }
  }
  
  &-item {
    flex: 1;
    width: 440px;
    
    @media screen and (max-width: 1400px) {
      width: 400px;
    }
    
    @media screen and (max-width: 1400px) {
      width: 360px; // 1200px以下不再缩小
    }
    
    // @media screen and (max-width: 768px) {
    //   width: 100%;
    // }
  }
  
  &-box {
    position: relative;
    width: 100%;
    height: 300px;
    
    @media screen and (max-width: 1400px) {
      height: 280px;
    }
    
    @media screen and (max-width: 1400px) {
      height: 260px; // 1200px以下不再缩小
    }
    
    // @media screen and (max-width: 768px) {
    //   height: 200px;
    // }
    
    // @media screen and (max-width: 480px) {
    //   height: 180px;
    // }
  }
  
  &-mask {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.4);
    z-index: 2;
    
    .el-icon-video-play {
      position: absolute;
      right: 36px;
      bottom: 36px;
      font-size: 36px;
      color: #fff;
      z-index: 3;
      
      @media screen and (max-width: 1400px) {
        right: 32px;
        bottom: 32px;
        font-size: 32px;
      }
      
      @media screen and (max-width: 1400px) {
        right: 28px;
        bottom: 28px;
        font-size: 28px; // 1200px以下不再缩小
      }
      
      // @media screen and (max-width: 768px) {
      //   right: 20px;
      //   bottom: 20px;
      //   font-size: 20px;
      // }
      
      // @media screen and (max-width: 480px) {
      //   right: 15px;
      //   bottom: 15px;
      //   font-size: 18px;
      // }
    }
  }
  
  &-title {
    width: 100%;
    padding-top: 40px;
    padding-bottom: 14px;
    line-height: 28px;
    font-weight: bold;
    font-size: 24px;
    color: #663301;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    
    @media screen and (max-width: 1400px) {
      padding-top: 35px;
      font-size: 22px;
    }
    
    @media screen and (max-width: 1400px) {
      padding-top: 30px;
      font-size: 20px; // 1200px以下不再缩小
    }
    
    // @media screen and (max-width: 768px) {
    //   padding-top: 20px;
    //   padding-bottom: 10px;
    //   font-size: 16px;
    // }
    
    // @media screen and (max-width: 480px) {
    //   padding-top: 15px;
    //   padding-bottom: 8px;
    //   font-size: 14px;
    // }
  }
  
  &-desc {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 18px;
    color: #4f4f4f;
    line-height: 24px;
    
    @media screen and (max-width: 1400px) {
      font-size: 17px;
      line-height: 22px;
    }
    
    @media screen and (max-width: 1400px) {
      font-size: 16px;
      line-height: 20px; // 1200px以下不再缩小
    }
    
    // @media screen and (max-width: 768px) {
    //   font-size: 13px;
    //   line-height: 15px;
    // }
    
    // @media screen and (max-width: 480px) {
    //   font-size: 12px;
    //   line-height: 14px;
    // }
  }
}

.btn {
  width: 192px;
  height: 45px;
  
  @media screen and (max-width: 1400px) {
    width: 180px;
    height: 42px;
  }
  
  @media screen and (max-width: 1400px) {
    width: 170px;
    height: 40px; // 1200px以下不再缩小
  }
  
  // @media screen and (max-width: 768px) {
  //   width: 140px;
  //   height: 34px;
  // }
  
  // @media screen and (max-width: 480px) {
  //   width: 130px;
  //   height: 32px;
  // }
}
</style>
